<template>
    <div class="rp-order-receipt">
        <div class="rp-order-receipt__header">
            {{$t('orderList.receiptTitle', { productCount })}}
        </div>
        <div class="rp-order-receipt__content">
            <div
                class="rp-order-receipt__content____item"
                v-for="(product, index) in products"
                :key="index+'products'"
                >
                <img :src="product.imageURL[0]" @error="product.error = true" v-if="product.imageURL && !product.error"/>
                <img src="@/assets/img/No-Image.jpg"  v-else />
                <div class="rp-order-receipt__content____item______content">
                    <div class="rp-order-receipt__content____item______content________title">
                        {{ product.name}}
                    </div>
                    <div class="rp-order-receipt__content____item______content________desc">
                        {{ getQuantityDesc(product) }}
                    </div>
                </div>
                <div class="rp-order-receipt__content____item______price" :title="product.price * product.quantity">
                        {{ currencySymbol }}{{ abbreviateNumber(product.price * product.quantity, 'price')}}
                </div>
            </div>
            <div class="rp-order-receipt__content____break-bill">
                <div class="rp-order-receipt__content____break-bill______row">
                    <span>{{$t('orderList.itemTotal')}}</span>
                <span :title="itemTotal(orderData.products)">{{ currencySymbol }}{{ abbreviateNumber(itemTotal(orderData.products), 'price')}}</span>
                </div>
                <div class="rp-order-receipt__content____break-bill______row">
                    <span>{{$t('orderList.taxes')}}
                        <span class="receipt__content____break__subtitle" v-if="orderData.taxesIncluded">(Included in items total)</span>
                    </span>
			        <span :title="orderData.taxAmount" v-if="abbreviateNumber(orderData.taxAmount)">{{ currencySymbol }}{{abbreviateNumber(orderData.taxAmount, 'price')}}</span>
                    <span v-else>0.00</span>
                </div>
                <div class="rp-order-receipt__content____break-bill______row">
                    <span>{{$t('orderList.deliveryCharges')}}</span>
			        <span>{{shippingPrice(orderData)}} </span>
                </div>

                <div class="rp-order-receipt__content____break-bill______row">
                    <span>{{$t('orderList.discounts')}}</span>
			        <span :title="orderData.discountAmount" v-if="abbreviateNumber(orderData.discountAmount)">-{{ currencySymbol }}{{abbreviateNumber(orderData.discountAmount, 'price')}}</span>
                    <span v-else>0.00</span>
                </div>
                <div class="rp-order-receipt__content____break-bill______row">
                    <span class="rp-order-total-bill-label">{{$t('orderList.total')}}</span>
			        <span class="rp-order-total-bill-label" :title="orderData.amount" >{{ currencySymbol }}{{abbreviateNumber(orderData.amount, 'price')}} </span>
                </div>
                <div class="rp-order-receipt__content____break-bill______row"
                    :key="index"
                    v-for="(item, index) in giftCards"
                >
                    <span>{{$t('orderList.giftCard')}} ({{item.name || ''}})</span>
			        <span :title="item.price" v-if="abbreviateNumber(item.price)">-{{ currencySymbol }}{{abbreviateNumber(item.price, 'price')}}</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { abbreviateNumber } from '../../../constants';

export default {
    props: {
        orderData: {
            type: Object,
            required: true,
        }
    },

    data() {
        return {};
    },

    computed: {
        giftCards() {
            const { giftCards } = this.orderData
            try {
                return JSON.parse(giftCards)
            } catch (e) {
                return []
            }
            return []
        },
        productCount() {
            return this.products.length ? this.products.length : 1;
        },

        currencySymbol() {
			return this.$root.configuration.currency.symbol;
        },

        products() {
            return this.orderData.products || [];
        }
    },

    methods: {
        abbreviateNumber,
        getQuantityDesc(product) {
            const {
                price,
                quantity
            } = product;
            let fixedPrice = price;
            
            if(!fixedPrice) fixedPrice = 0;

            fixedPrice = fixedPrice.toFixed(2)
            
            return `${this.currencySymbol}${fixedPrice} X ${quantity}`
        },

        itemTotal(products) {
            let itemTotal = 0;
            products.forEach(product => {
                itemTotal += (product.price * (product.quantity || 0));
            });
            return itemTotal;
        },

		shippingPrice(orderData){
			if (orderData.shippingAmount === 0){
				return this.$t("orderList.free")
			}
			else {
				return orderData.shippingAmount ? this.currencySymbol + orderData.shippingAmount : '0.00';
			}
        },
    }


}
</script>
<style lang="scss" scoped>
.rp-order-receipt {
    .rp-order-receipt__header {
        border-top-right-radius: 4px;
        border-top-left-radius: 4px;
        background: #f9f9f9;
        border-bottom: 1px solid #e6e6e6;
        padding: 15px 20px;
        font-size: 18px;
        color: #333333;
        font-weight: 400;
        line-height: 1;
        @include for-size(tablet-landscape-up) {
            padding: 30px 40px;
        }
        @include for-size(desktop-up){
            padding: $desktopPadding;
            font-size: 26px;
        }

        text-transform: capitalize;
    }
    .rp-order-receipt__content {
        color: #666;
        font-size: 14px;
        @include for-size(desktop-up){
            font-size: 19px;
        }
        .rp-order-receipt__content____item {
            border-bottom: 1px solid #e6e6e6;
            padding: 20px;
            align-items: center;
            @include for-size(tablet-landscape-up) {
                padding: 30px 40px;
            }
            @include for-size(desktop-up){
                padding: 30px 60px;
            }
            display: flex;
            img {
                height: 35px;
                width: 35px;
                margin-right: 20px;
                border: 1px solid #eeeeee;
                border-radius: 4px;
                @include for-size(desktop-up) {
                    height: 48px;
                    width: 48px;
                }
            }
            .rp-order-receipt__content____item______content {
                flex: 1;
                .rp-order-receipt__content____item______content________title {
                    color: #333333;
                    font-weight: 500;
                }
                .rp-order-receipt__content____item______content________desc {
                }
            }
            .rp-order-receipt__content____item______price {
                margin-left: 20px;
            }
        }
        .rp-order-receipt__content____break-bill {
            padding: 20px;
            @include for-size(tablet-landscape-up) {
                padding: 30px 40px;
            }
            @include for-size(desktop-up){
                padding: 30px 60px;
            }
            .rp-order-receipt__content____break-bill______row {
                display: flex;
                align-items: center;
                justify-content: space-between;
                .receipt__content____break__subtitle {
                    font-size: 11px;
                }
                .rp-order-total-bill-label {
                    font-weight: 500;
                    color: #333333;
                }
                +.rp-order-receipt__content____break-bill______row {
                    padding-top: 10px;
                }
            }
        }
    }
    
}
</style>